import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import utilService from "./utilsService";
import {CountriesI, CountryI, LGAI, RelationshipOfficerDetailsI, StatesI, TeamDetailsI} from "../../interfaces";

interface UtilSliceI {
    isLoading: boolean;
    isSuccessful: boolean;
    allStates: StatesI;
    allCountries: CountryI[];
    lgas: LGAI;
    paymentitems: any;
    relationshipOfficerDetails: RelationshipOfficerDetailsI,
    teamDetails:TeamDetailsI[] ,
}


const initialState: UtilSliceI = {
    isLoading: false,
    isSuccessful: false,
    allStates: { },
    lgas: {},
    paymentitems:{},
    allCountries:[],
    teamDetails:[],
    relationshipOfficerDetails: {
        name: "",
        email: "",
        phoneNumber: "",
    },
};

export const getStates = createAsyncThunk(
    "utils/getStates",
    async (data, { rejectWithValue }) => {
        try {
            const response = await utilService.getStates();
            if (response.status === 200) {
                toast.success(response?.data.message);
            } else {
                toast.error(response?.data?.statusMessage);
            }
            return response.data.responseObject?.states;
        } catch (error) {
            const err = error as AxiosError<{ message: string }>;
            toast.error(err.response?.data.message);
            return err?.response?.data;
        }
    }
);




export const getReferralAndRewards = createAsyncThunk(
    "SelfServices/getmytransfer",
    async (payload:any, { rejectWithValue }) => {
        try {
            const response = await utilService.getmytransfer(payload);
            if (response.status === 200) {
                toast.success(response?.data.message);
            } else {
                toast.error(response?.data?.statusMessage);
            }
          //  console.log('data from getmytransfer',response?.data)
            return response.data;
        } catch (error) {
            const err = error as AxiosError<{ message: string }>;
            toast.error(err.response?.data.message);
            return err?.response?.data;
        }
    }
);



export const getLGA = createAsyncThunk(
    "utils/getLGA",
    async (payload:any, { rejectWithValue }) => {
        try {
            const response = await utilService.getLGA(payload);
            if (response.status === 200) {
                return response.data.responseObject?.lgAs;
            } else {
                toast.error(response?.data?.statusMessage);
            }
            return {}
        } catch (error) {
            const err = error as AxiosError<{ message: string }>;
            toast.error(err.response?.data.message);
            return err?.response?.data;
        }
    }
);



export const getCountries = createAsyncThunk(
    "SelfServices/country",
    async (data, { rejectWithValue }) => {
        try {
            const response = await utilService.getCountries();
            if (response.status === 200) {
                toast.success(response?.data.message);
            } else {
                toast.error(response?.data?.statusMessage);
            }
            return response.data.responseObject;
        } catch (error) {
            const err = error as AxiosError<{ message: string }>;
            toast.error(err.response?.data.message);
            return err?.response?.data;
        }
    }
);




export const GetTeams = createAsyncThunk(
    "v2/SelfServices/getteams",
    async (_, { rejectWithValue }) => {
        try {
            const response = await utilService.getTeams();
            if (response.status === 200) {
                return response.data.responseObject;
            } else {
                toast.error(response?.data?.statusMessage);
            }
            return {}
        } catch (error) {
            const err = error as AxiosError<{ message: string }>;
            toast.error(err.response?.data.message);
            return err?.response?.data;
        }
    }
);


export const GetRelationshipOfficerDetails = createAsyncThunk(
    "utils/GetRelationshipOfficerDetails",
    async (_, { rejectWithValue }) => {
        try {
            const response = await utilService.getRelationshipOfficerDetails();
            if (response.status === 200) {
                return response.data.responseObject;
            } else {
                toast.error(response?.data?.statusMessage);
            }
            return {}
        } catch (error) {
            const err = error as AxiosError<{ message: string }>;
            toast.error(err.response?.data.message);
            return err?.response?.data;
        }
    }
);

export const utilsSlice = createSlice({
    name: "utils",
    initialState,
    reducers: {
        noTract: () => {},
    },
    extraReducers: (builder) => {
        builder
            .addCase(getStates.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(getStates.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                    allStates: action.payload
                };
            })
            .addCase(getStates.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })


            .addCase(getCountries.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(getCountries.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                    allCountries: action.payload
                };
            })
            .addCase(getCountries.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })


            .addCase(getLGA.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                    lgas: {}
                };
            })
            .addCase(getLGA.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                    lgas: action.payload
                };
            })
            .addCase(getLGA.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })




            .addCase(getReferralAndRewards.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                    // lgas: {}
                };
            })
            .addCase(getReferralAndRewards.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                    paymentitems: action.payload
                };
            })
            .addCase(getReferralAndRewards.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            })

            
            .addCase(GetRelationshipOfficerDetails.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(GetRelationshipOfficerDetails.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                    relationshipOfficerDetails: action.payload
                };
            })
            .addCase(GetRelationshipOfficerDetails.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            }) 
            
            
            .addCase(GetTeams.pending, (state, action) => {
                return {
                    ...state,
                    isLoading: true,
                    isSuccessful: false,
                };
            })
            .addCase(GetTeams.fulfilled, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: true,
                    teamDetails: action.payload
                };
            })
            .addCase(GetTeams.rejected, (state, action) => {
                return {
                    ...state,
                    isLoading: false,
                    isSuccessful: false,
                };
            });
    },
});

export default utilsSlice.reducer;